<template>
  <div>
    <spinner :show="isLoading" />
    <form ref="familyForm" :show="!isLoading" class="sa-form" @submit.prevent="onSubmit">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="firstName">First Name<span class="label-required">*</span></label>
          <input
            id="firstName"
            v-model="firstName"
            class="form-control"
            type="text"
            placeholder="First Name"
            required="true"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="lastName">Last Name<span class="label-required">*</span></label>
          <input
            id="lastName"
            v-model="lastName"
            class="form-control"
            type="text"
            placeholder="Last Name"
            required="true"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="address">Address<span class="label-required">*</span></label>
          <input
            v-if="isIE11"
            v-model="streetAddress"
            required="true"
            class="form-control"
            type="text"
            placeholder="1234 Main St"
          />
          <vue-bootstrap-typeahead
            v-else
            ref="typeaheadComponent"
            v-model="address"
            input="address"
            input-class="input-address"
            :serializer="item => item ? `${item.street_line} ${item.city}, ${item.state}` : ''"
            :data="addressList"
            placeholder="1234 Main St"
            @hit="onSearchSelection"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="address2">Address 2</label>
          <input
            id="address2"
            v-model="address2"
            class="form-control"
            type="text"
            placeholder="Apt 2"
          />
        </div>
        <div class="form-group col-md-2">
          <label for="zipcode">Zip Code<span class="label-required">*</span></label>
          <input
            id="zipcode"
            v-model="zipcode"
            class="form-control"
            type="text"
            pattern="[0-9]{5}"
            title="Please enter a five-digit zip code"
            maxlength="5"
            placeholder="Zip"
            required="true"
          />
        </div>
      </div>
      <small class="form-row">
        <span class="label-required">*</span> required field
      </small>
      <div class="form-row mr-1">
        <div class="ml-auto">
          <button
            class="btn my-4 waves-effect z-depth-0"
            type="submit"
          >
            Add recipient
          </button>
          <button
            class="btn btn-outline my-4 waves-effect z-depth-0"
            type="reset"
            @click="onClearForm($event)"
          >
            Clear Form
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import _ from 'lodash';
import Spinner from '../Spinner';

export default {
  name: 'FamilyForm',
  components: { VueBootstrapTypeahead, Spinner },
  props: {
    submissionHandler: {
      type: Function,
      default: function () {
        return {};
      }
    },
    cancelText: {
      type: String,
      default: 'Reset',
    },
    submitText: {
      type: String,
      default: 'Submit'
    }
  },
  data() {
    return {
      isIE11: false,
      firstName: '',
      lastName: '',
      address: '', // the constructed address that is in the field
      streetAddress: '', // the real value of street address that will be used
      address2: '',
      city: '',
      state: '',
      zipcode: '',
      addressList: [],
      addressSearchSelection: null,
    }
  },
  computed: {
    isLoading: function() {
      return this.$store.getters.getIsRecipientLoading;
    },
  },
  watch: {
    //eslint-disable-next-line
    address: function(val, oldVal) {
      // change of userinput, do something
      this.addressLookup(val);
    },
  },
  mounted() {
    this.resetData();
    this.checkIE11();
    this.$nextTick(function() {
      let formInput = this.$el.querySelector('.input-address');
      if (formInput) { formInput.required = true; }
    })
  },
  methods: {
    //eslint-disable-next-line
    resetData: function(e) {
      this.firstName = '';
      this.lastName = '';
      this.address = ''; // the constructed address that is in the field
      this.streetAddress = ''; // the real value of street address that will be used
      this.address2 = '';
      this.city = '';
      this.state = '';
      this.zipcode = '';
      this.addressList = [];
      this.addressSearchSelection = null;

      this.clearForm();
    },
    onSubmit(e) {
      if (this.isIE11) {
        this.city = 'NA';
        this.state = 'NA';
      }
      const values = {
        firstName: this.firstName,
        lastName: this.lastName,
        addressLine1: this.streetAddress,
        addressLine2: (this.address2 != '') ? this.address2 : null,
        city: this.city,
        state: this.state,
        zip: this.zipcode
      };
      this.submissionHandler(values, () => this.resetData(e));
    },
    addressLookup: _.debounce(async function(val) {
      const url = `https://us-autocomplete.api.smartystreets.com/suggest?key=24155327197896763&prefix=${val}`;
      try {
        const res = await axios({ url, method: 'get' });
        this.addressList = res.data && res.data.suggestions ? res.data.suggestions : [];
      } catch (err) {
        console.log('Error: ', err)
      }
    }, 200),
    onSearchSelection(value) {
      this.city = value.city;
      this.state = value.state;
      this.streetAddress = value['street_line'];
    },
    checkIE11() {
      let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
      this.isIE11 = isIE11;
    },
    clearForm() {
      if (this.$refs.typeaheadComponent) {
        this.$refs.typeaheadComponent.inputValue = '';
      }
      if (this.$refs.familyForm) {
        this.$refs.familyForm.reset();
      }
    },
    //eslint-disable-next-line
    onClearForm(event) {
      this.resetData();
    }
  }
}
</script>
